import BilgeWater from "../assets/img/loader-images/bilgewater.webp";
import Demacia from "../assets/img/loader-images/demacia.jpeg";
import Freljord from "../assets/img/loader-images/freljord.webp";
import Ionia from "../assets/img/loader-images/ionia.webp";
import Noxus from "../assets/img/loader-images/noxus.jpeg";
import Piltower from "../assets/img/loader-images/piltower.jpeg";

export const LoaderImgs = [BilgeWater, Demacia, Freljord, Ionia, Noxus, Piltower];




